import type { Goal } from '@atlassian/jira-business-goal-picker';
import { GOALS_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { GOALS_GQL_TYPE } from '../constants';
import type { jiraBusinessGoalsField } from '../fragment/types';
import type { TransformedGoals } from '../types';

export const transformGoalsField = () => ({
	[GOALS_GQL_TYPE]: (field: jiraBusinessGoalsField): TransformedGoals | null => {
		if (field.__typename !== GOALS_GQL_TYPE) {
			return null;
		}

		return {
			type: GOALS_CF_TYPE,
			fieldId: field.fieldId,
			name: field.name,
			isEditable: !!field.fieldConfig?.isEditable,
			value: {
				goals:
					field.selectedGoals?.edges
						?.filter((edge) => edge?.node !== null)
						.map(
							(edge): Goal => ({
								id: edge?.node?.id || '',
								name: edge?.node?.name || '',
								status: edge?.node?.status || null,
							}),
						) || [],
				totalCount: field.selectedGoals?.totalCount || 0,
			},
		};
	},
});
